export const LOGIN = "login";
export const LOGIN2 = "login2";

export const PAGE_HEADER_ACTIVE = "pageHeader/active";

export const CLOUD_ROUTE = "cloud/route";

export const APP_SYSTEMS = "app/systems";
export const APP_MENUS = "app/menus";
export const APP_ACTIVE = "app/active";
export const APP_MENU_ACTIVE = "app/menu_active";
export const APP_REMOVE_TAB = "app/remove_tab";
export const APP_ADD_LOCAL_TAB = "app/add_local_tab";
export const APP_REMOVE_TABS = "app/remove_tabs";
export const APP_REMOVE_OTHER_TABS = "app/remove_other_tabs";
export const APP_CURRENT_USER = "app/current_user";
export const APP_USER_INFO = "app/user_info";
export const APP_GET_TOKEN = "app/getToken";
export const APP_UNIFY_INFO_LOG = "app/unifyInfoLog";
export const APP_REFRESH_COOKIE = "app/refreshCookie";

export const HOME_MENUS = "home/menus";

export const HOME_INCREASE_TAB = "home/increase_tab";

// common
export const COMMON_AREAS = "common/areas";
export const COMMON_AREAS_CHANGE = "common/areas_change";
export const COMMON_CITY_COMPANY = "common/city_company";
export const COMMON_CITY_COMPANY_CHANGE = "common/city_company_change";
export const COMMON_CITY_COMPANY_CLEAR = "common/city_company_clear";
export const COMMON_PROJECTS = "common/projects";
export const COMMON_BUSINESS_LIST = "common/business_list";
export const COMMON_PROJECT_RESOURCE_LIST = "common/project_resource_list";
export const COMMON_PROJECT_RESOURCE_PARAMS_LIST = "common/project_resource_params_list";
export const COMMON_PROJECTS_CLEAR = "common/projects_clear";
export const COMMON_ORG_TREE = "common/org_tree";
export const COMMON_ALL_ORG_TREE = "common/allOrgTree";
export const COMMON_STAFF_DATA_TREE = "common/staffDataTree";
export const COMMON_SYSAREA_AREATREE = "common/sysarea_areatree";
export const COMMON_PROJECT_RESOURCE_PROJECTS = "common/project_resource_projects";
export const COMMON_PROJECT_RESOURCE_PROJECTS_DA = "common/project_resource_projects_da";
export const COMMON_ORG_AREA_CITY_BY_PROJECTIDS = "common/org_arr_city_projectids";
export const COMMON_PROJECT_STAFF = "common/projectStaff";
export const COMMON_RESOURCE_TREE_BY_PARENT = "common/resourceTreeByParent";
export const COMMON_STAFFS = "common/staffs";
export const COMMON_PROJECTS_BY_PAGE = "common/projectsByPage";

// decision
export const DECISION_EXTRA_TAB = "decision/extra_tab";
export const DECISION_ACTIVE_MENU_ID = "decision/active_menu_id";
export const DECISION_INCREASE_TAB = "decision/increase_tab";
export const DECISION_ROUTE = "decision/route";
export const DECISION_REMOVE_TAB = "decision/remove_tab";
export const DECISION_MY_PROJECT = "decision/myProjects";
export const DECISION_PROJECT_BUSINESS = "decision/projectBusiness";
export const DECISION_MY_REGIONS = "decision/myRegions";
export const DECISION_MENUS = "decision/menus";
export const DECISION_MENULIST = "decision/menuList";
export const DECISION_DICTIONARY = "decision/dictionary";

//order
export const ORDER_SYSTEMS = "order/systems";
export const ORDER_SYSTEM_ORDER = "order/systems_order";

//setting
export const SETTING_INCREASE_TAB = "setting/increase_tab";
export const SETTING_SUB_SYSTEM_LIST = "feature/sub_system_list";
export const SETTING_SUB_SYSTEM_MENUS = "feature/sub_system_menus";
export const SETTING_SUB_SYSTEM_BUTTONS = "feature/sub_system_buttons";
export const SETTING_SUB_SYSTEM_CREATE = "feature/sub_system_create";
export const SETTING_SUB_SYSTEM_MODIFY = "feature/sub_system_modify";
export const SETTING_MENU_MODIFY = "feature/menu_modify";
export const SETTING_MENU_CREATE = "feature/menu_create";
export const SETTING_RESET_FOR_SYS = "feature/resetForSys";
export const SETTING_RESET_FOR_MENU = "feature/resetForMenu";
export const SETTING_SUB_SYSTEM_CLEAR = "feature/sub_system_clear";


export const SETTING_ROLE_LIST = "roles/list";
export const SETTING_ROLE_CREATE = "roles/create";
export const SETTING_ROLE_MODIFY = "roles/modify";
export const SETTING_ROLE_CLEAR = "roles/clear";
export const SETTING_ROLE_NORMAL_LIST = "roles/normal_list";
export const SETTING_ROLE_LIST_BY_MANAGER = "roles/role_list_by_manager";
export const SETTING_ROLE_RELATION = "roles/role_relation";
export const SETTING_ROLE_APP_TREE = "roles/role_app_tree";
export const SETTING_ROLE_ALLOCATE_BUTTON_LIST = "roles/role_allocate_button_list";
export const SETTING_ROLE_ALLOCATE_BUTTON_SAVE = "roles/role_allocate_button_save";
export const SETTING_RULE_FIND_SYSTEM_BY_ROLE = "roles/findSystemByRole";
export const SETTING_RULE_FIND_MENU_BY_ROLE_AND_PARENT = "roles/findMenuByRoleAndParent";

export const SETTING_TENANCY_LIST = "tenancy/list";
export const SETTING_TENANCY_CREATE = "tenancy/create";
export const SETTING_TENANCY_MODIFY = "tenancy/modify";
export const SETTING_TENANCY_ALLOCATE = "tenancy/allocate";
export const SETTING_TENANCY_SAVE_LIST = "tenancy/save_list";
export const SETTING_TENANCY_CHECKED_LIST = "tenancy/checked_list";
export const SETTING_TENANCY_CHECKED_BUTTON_LIST = "tenancy/checked_button_list";

export const SETTING_RULE_SYNC_SAVE = "SettingRuleSync/save";
export const SETTING_RULE_SYNC_MODIFY = "SettingRuleSync/modify";
export const SETTING_RULE_SYNC_COPY = "SettingRuleSync/copy";
export const SETTING_RULE_SYNC_CLEAR = "SettingRuleSync/clear";
export const SETTING_RULE_SYNC_LIST = "SettingRuleSync/list";

export const SETTING_RULE_SUBSYSTEM_LIST = "SettingRuleSubsystem/list";
export const SETTING_RULE_SUBSYSTEM_MODIFY = "SettingRuleSubsystem/modify";

export const SETTING_RULE_FIELD_MODIFY = "SettingRuleField/modify";
export const SETTING_RULE_FIELD_LIST = "SettingRuleField/list";
export const SETTING_RULE_FIELD_SAVE = "SettingRuleField/save";
export const SETTING_RULE_FIELD_COPY = "SettingRuleField/copy";
export const SETTING_RULE_FIELD_CLEAR = "SettingRuleField/clear";
export const SETTING_RULE_FIELD_SET_OBJECT_ID = "SettingRuleField/setObjectId";
export const SETTING_DICTIONARY_DICT_TYPES = "SettingDictionary/dictTypes";
export const SETTING_DICTIONARY_DICT_VALUE = "SettingDictionary/dictValue";
export const SETTING_DICTIONARY_DICT_VALUE_CHILD = "SettingDictionary/dictValueChild";

export const SETTING_DICTIONARY_DICT_TYPE_CREATE = "SettingDictionary/createDictType";
export const SETTING_DICTIONARY_DICT_TYPE_MODIFY = "SettingDictionary/modifyDictType";
export const SETTING_DICTIONARY_DICT_TYPE_DELETE = "SettingDictionary/deleteDictType";
export const SETTING_DICTIONARY_DICT_TYPE_DISABLE = "SettingDictionary/disableDictType";
export const SETTING_DICTIONARY_DICT_TYPE_ENABLE = "SettingDictionary/enableDictType";

export const SETTING_DICTIONARY_DICT_VALUE_CREATE = "SettingDictionary/createDictValue";
export const SETTING_DICTIONARY_DICT_VALUE_MODIFY = "SettingDictionary/modifyDictValue";
export const SETTING_DICTIONARY_DICT_VALUE_DISABLE = "SettingDictionary/disableDictValue";
export const SETTING_DICTIONARY_DICT_VALUE_ENABLE = "SettingDictionary/enableDictValue";


// setting org
export const SETTING_ORG_TREE = "org/tree";
export const SETTING_ORG_TREE_NEW = "org/tree_new";
export const SETTING_ORG_LIST = "org/list";
export const SETTING_ORG_LIST_NEW = "org/list_new";
export const SETTING_ORG_CREATE = "org/create";
export const SETTING_ORG_MODIFY = "org/modify";
export const SETTING_ORG_MARK = "org/mark";
export const SETTING_ORG_UPDATE = "org/update";
export const SETTING_ORG_FORM_CLEAR = "org/form_clear";
export const SETTING_ORG_GRID_CLEAR = "org/grid_clear";
export const SETTING_ORG_DICT_TYPES = "org/dict_types";
export const SETTING_ORG_MOVE = "org/move";
export const SETTING_ORG_MOVE_TREE_DATA = "org/move_tree_data";
export const SETTING_ORG_MOVE_TREE_DATA_NEW = "org/move_tree_data_new";

// setting pos
export const SETTING_POST_ORG_FIND_TREE = "post/org_find_tree";
export const SETTING_ORG_TREE_FIND_LIST = "post/find_pos";
export const SETTING_ORG_POST_CREATE = "post/create";
export const SETTING_ORG_POST_MODIFY = "post/modify";
export const SETTING_ORG_POST_WB_ADD = "post/wbaoe";//aoe表示add or edit
export const SETTING_ORG_POST_CHANGE_STATUS = "post/change_status";
export const SETTING_ORG_POST_WB_CHANGE_STATUS = "post/wb_change_status";
export const SETTING_ORG_POST_WB_UPDATE = "post/wb_update";
export const SETTING_ORG_POST_WB_PERSONNEL = "post/wb_personnel";
export const SETTING_ORG_POST_WB_NAME_PERSONLIST = "post/wb_name_personlist";//按名称模糊查询所有的外包人员
export const SETTING_ORG_POST_WB_REMOVE_PERSON = "post/wb_remove_person";//删除某岗位下的人员
export const SETTING_ORG_POST_WB_ADD_PERSON = "post/wb_add_person";//新增某岗位下的人员
export const SETTING_POS_ORG_FIND_ROLE_LIST = "post/org_find_role_list";
export const SETTING_POST_ORG_FIND_ROLE_LIST_ID = "post/org_find_role_list_id";
export const SETTING_ORG_POST_REMOVE_ROLE = "post/org_post_remove_role";
export const SETTING_POS_DATA_AUTH_FIND_TREE_ID = "post/data_auth_find_tree_id";
export const SETTING_POS_DATA_AUTH_FIND_PROJECT_TREE = "post/data_auth_find_project_tree";
export const SETTING_POS_DATA_AUTH_FIND_ORG_TREE_ID = "post/data_auth_find_org_tree_id";
export const SETTING_POS_DATA_AUTH_SAVE = "post/data_auth_save";

// setting wbemployee
export const SETTING_ORG_POST_WB_PERSONLIST = "post/wb_personlist";//查询所有的外包人员
export const SETTING_ORG_POST_WB_POST_TREE = "post/wb_post_tree";//查询所有的外包人员
export const SETTING_ORG_POST_WB_ADD_PERSONNEL = "post/wb_add_personnel";//新增外包人员
export const SETTING_ORG_POST_WB_EDIT_PERSONNEL = "post/wb_edit_personnel";//修改外包人员
export const SETTING_ORG_POST_WB_CHANGE_PWD = "post/wb_change_pwd";//修改外包人员

// setting employee
export const SETTING_ORG_EMPLOYEE_CREATE = "employee/create";
export const SETTING_ORG_EMPLOYEE_MODIFY = "employee/modify";
export const SETTING_ORG_EMPLOYEE_LIST = "employee/employee_list";
export const SETTING_DICK_FIND_CODE = "setting/dict_find_code";
export const SETTING_ORG_EMPLOYEE_FIND_ROLE_LIST = "employee/employee_find_role_list";
export const SETTING_ORG_EMPLOYEE_REMOVE_STAFF_MENU = "employee/employee_remove_staff_menu";
export const SETTING_ORG_EMPLOYEE_FIND_MENU_ROLE_ID = "employee/employee_find_menu_role_id";
export const SETTING_EMPLOYEE_FIND_STAFF_POS_TREE = "employee/employee_find_staff_pos_tree";
export const SETTING_EMPLOYEE_FIND_MENU_LIST = "employee/employee_find_menu_list";
export const SETTING_EMPLOYEE_DATA_AUTH_FIND_ORG_STAFF_TREE = "employee/data_auth_find_org_staff_tree";
export const SETTING_EMPLOYEE_DATA_AUTH_SAVE_STAFF_REMOVE = "employee/data_auth_save_staff_remove";
export const SETTING_EMPLOYEE_ORG_FIND_TREE = "employee/orgFindTree";
// export const SETTING_JURISDICTION_ORG_FIND_TREE="employee/org_find_tree"
// setting property
export const SETTING_PROPERTY_POST_FIND_LIST = "propertyPost/property_post_list";
export const SETTING_PROPERTY_POST_FIND_ROLE_LIST = "propertyPost/property_post_role_list";
export const SETTING_PROPERTY_POST_FIND_ROLE_LIST_ID = "propertyPost/property_post_role_list_id";
export const SETTING_PROPERTY_POST_FIND_KEY = "propertyPost/property_post_key";
export const SETTING_PROPERTY_POST_CREATE = "propertyPost/property_post_create";
export const SETTING_PROPERTY_POST_MODIFY = "propertyPost/property_post_modity";
export const SETTING_PROPERTY_ROLE_LIST = "propertyPost/roleList";
export const SETTING_PROPERTY_POST_FIND_POS = "propertyPost/property_post_find_pos";
export const SETTING_PROPERTY_POST_FIND_MENU_ROLE_ID = "propertyPost/property_post_find_menu_role_id";
export const SETTING_PROPERTY_POST_SAVE_PROPERTY_ROLE = "propertyPost/property_post_save_property_role";

// setting property standard
export const SETTING_PROPERTY_STANDARD_POST_FIND_LIST = "propertyPostStandard/property_post_list";
export const SETTING_PROPERTY_STANDARD_POST_FIND_ROLE_LIST = "propertyPostStandard/property_post_role_list";
export const SETTING_PROPERTY_STANDARD_POST_FIND_ROLE_LIST_ID = "propertyPostStandard/property_post_role_list_id";
export const SETTING_PROPERTY_STANDARD_POST_FIND_KEY = "propertyPostStandard/property_post_key";
export const SETTING_PROPERTY_STANDARD_POST_CREATE = "propertyPostStandard/property_post_create";
export const SETTING_PROPERTY_STANDARD_POST_MODIFY = "propertyPostStandard/property_post_modity";
export const SETTING_PROPERTY_STANDARD_ROLE_LIST = "propertyPostStandard/roleList";
export const SETTING_PROPERTY_STANDARD_POST_FIND_POS = "propertyPostStandard/property_post_find_pos";
export const SETTING_PROPERTY_STANDARD_POST_FIND_MENU_ROLE_ID = "propertyPostStandard/property_post_find_menu_role_id";
export const SETTING_PROPERTY_STANDARD_POST_SAVE_PROPERTY_ROLE = "propertyPostStandard/property_post_save_property_role";

// setting property manage
export const SETTING_PROPERTY_MANAGE_POST_LIST = "SettingPropertyManage/postList"
export const SETTING_PROPERTY_MANAGE_SAVE = "SettingPropertyManage/save"
export const SETTING_PROPERTY_MANAGE_UPDATE = "SettingPropertyManage/update"
export const SETTING_PROPERTY_MANAGE_SET_ID = "SettingPropertyManage/setId"
export const SETTING_PROPERTY_MANAGE_FIND_POST_BY_ID = "SettingPropertyManage/findPostById"
export const SETTING_PROPERTY_MANAGE_ADD_TO_RIGHT = "SettingPropertyManage/addToRight"
export const SETTING_PROPERTY_MANAGE_DELETE_FROM_RIGHT = "SettingPropertyManage/deleteFromRight"
export const SETTING_PROPERTY_MANAGE_CHANGE_ORG = "SettingPropertyManage/changeOrg"
export const SETTING_PROPERTY_MANAGE_LEFT_SELECTION = "SettingPropertyManage/leftSelection"
export const SETTING_PROPERTY_MANAGE_RIGHT_SELECTION = "SettingPropertyManage/rightSelection"
export const SETTING_PROPERTY_MANAGE_CLEAR = "SettingPropertyManage/clear"

// setting property manage modify
export const SETTING_PROPERTY_MANAGE_MODIFY_LEFT_SELECTION = "SettingPropertyManageModify/leftSelection"
export const SETTING_PROPERTY_MANAGE_MODIFY_RIGHT_SELECTION = "SettingPropertyManageModify/rightSelection"
export const SETTING_PROPERTY_MANAGE_MODIFY_ADD_TO_RIGHT = "SettingPropertyManageModify/addToRight"
export const SETTING_PROPERTY_MANAGE_MODIFY_DELETE_FROM_RIGHT = "SettingPropertyManageModify/deleteFromRight"
export const SETTING_PROPERTY_MANAGE_MODIFY_CHANGE_ORG = "SettingPropertyManageModify/changeOrg"
export const SETTING_PROPERTY_MANAGE_MODIFY_POST_LIST = "SettingPropertyManageModify/postList"
export const SETTING_PROPERTY_MANAGE_MODIFY_UPDATE = "SettingPropertyManageModify/update"
export const SETTING_PROPERTY_MANAGE_MODIFY_FIND_POST_BY_ID = "SettingPropertyManageModify/findPostById"
export const SETTING_PROPERTY_MANAGE_MODIFY_SET_ID = "SettingPropertyManageModify/setId"
export const SETTING_PROPERTY_MANAGE_MODIFY_CLEAR = "SettingPropertyManageModify/clear"


// setting restore
export const SETTING_RESTORE_REMOVE_ROLE_LIST = "SettingRestore/removeRoleList"
export const SETTING_RESTORE_MENU_LIST = "SettingRestore/menuList"
export const SETTING_RESTORE_DATA_LIST = "SettingRestore/dataList"
export const SETTING_RESTORE_RETRIEVE = "SettingRestore/retrieve"
export const SETTING_RESTORE_SYSTEM_LIST = "SettingRestore/systemList"
export const SETTING_RESTORE_RETRIEVE_ALL = "SettingRestore/retrieveAll"

// setting log
export const SETTING_LOG_LOG_TYPES = "SettingLog/logTypes"
export const SETTING_LOG_GENERAL = "SettingLog/all"
export const SETTING_LOG_DETAIL = "SettingLog/detail"
export const SETTING_LOG_CHANGE_PAGE = "SettingLog/changePage"
export const SETTING_LOG_CHANGE_SIZE = "SettingLog/changeSize"

// advertising
export const ADVERTISING_AD_LIST = "adList/ad_list";
export const ADVERTISING_AD_ACTIVEADMIN = "adList/ad_activeAdmin";
export const ADVERTISING_AD_LIST_CHANGE_CURRENT_PAGE = "adList/ad_list_change_current_page";
export const ADVERTISING_AD_LIST_CHANGE_CURRENT_SIZE = "adList/ad_list_change_current_size";
export const ADVERTISING_AD_LIST_RESET = "adList/ad_list_reset";
export const ADVERTISING_AD_ITEM = "adList/ad_item";
export const ADVERTISING_AD_ITEM_UPDATE = "adList/ad_item_update";
export const ADVERTISING_AD_ITEM_CREATE = "adList/ad_item_create";
export const ADVERTISING_AD_ITEM_DELETE = "adList/ad_item_delete";
export const ADVERTISING_AD_LIST_GB = "gbAdList/gb_ad_list";
// advertising global list
export const ADVERTISING_AD_ITEM_GB = "gbAdList/ad_item_gb";
export const ADVERTISING_AD_ITEM_UPDATE_GB = "gbAdList/ad_item_update_gb";
export const ADVERTISING_AD_LIST_RESET_GB = "gbAdList/ad_list_reset_gb";
export const ADVERTISING_AD_LIST_CHANGE_CURRENT_PAGE_GB = "gbAdList/ad_list_change_current_page_gb";
export const ADVERTISING_AD_ITEM_CREATE_GB = "gbAdList/ad_item_create_gb";
export const ADVERTISING_AD_ITEM_DELETE_GB = "gbAdList/ad_item_delete_gb";
// advertising calendar
export const ADVERTISING_CALENDAR_LIST = "adCalendar/list";
export const ADVERTISING_CALENDAR_LIST_GB = "adCalendar/list_gb";

// HDEC
export const HDEC_CONFIG_MANAGEMENT_HOME = "HDECConfigHome/plates";
export const HDEC_CONFIG_MANAGEMENT_HOME_CHOICE = "HDECConfigHome/plates_choice";
export const HDEC_CONFIG_MANAGEMENT_HOME_MODIFY = "HDECConfigHome/plates_modify";
export const HDEC_CONFIG_MANAGEMENT_HOME_DELETE = "HDECConfigHome/plates_delete";

export const HDEC_PROJECT_LIST = "HDECProjectBaseInfo/list";
export const HDEC_PROJECT_SET_AREAS = "HDECProjectBaseInfo/set_areas";
export const HDEC_PROJECT_AREA_CHANGE = "HDECProjectBaseInfo/area_change";
export const HDEC_PROJECT_CITY_COMPANIES_CHANGE = "HDECProjectBaseInfo/city_companies_change";
export const HDEC_PROJECT_CHANGE_PAGE = "HDECProjectBaseInfo/change_page";
export const HDEC_PROJECT_CHANGE_PAGE_SIZE = "HDECProjectBaseInfo/change_page_size";
export const HDEC_PROJECT_EXPORT = "HDECProjectBaseInfo/export";

export const HDEC_PROJECT_COOPERATION_LIST = "HDECProjectCooperation/list";
export const HDEC_PROJECT_COOPERATION_PROJECT_LIST = "HDECProjectCooperation/project_list";
export const HDEC_PROJECT_COOPERATION_BUSINESS_LIST = "HDECProjectCooperation/business_list";


export const HDEC_HOME_NOTIFICATION = "HDECHome/notification";
export const HDEC_HOME_PERCENTAGE = "HDECHome/percentage";
export const HDEC_HOME_ORDER_TREND = "HDECHome/order_trend";
export const HDEC_HOME_CONTRACT_OFFSET = "HDECHome/contract_offset";
export const HDEC_HOME_PROJECT_INCOME = "HDECHome/project_income";
export const HDEC_HOME_PROJECT_INCOME_AMOUNT = "HDECHome/project_income_amount";
export const HDEC_HOME_CHANGE_PAGE = "HDECHome/change_page";
export const HDEC_HOME_CHANGE_PAGE_SIZE = "HDECHome/change_page_size";


export const HDEC_AFTER_SALE_LIST = "HDECAfterSale/list";
export const HDEC_AFTER_SALE_COPY_MODIFY = "HDECAfterSale/copy_modify";
export const HDEC_AFTER_SALE_CONTRACT_LIST = "HDECAfterSale/contract_list";
export const HDEC_AFTER_SALE_MODIFY = "HDECAfterSale/modify";
export const HDEC_AFTER_SALE_CREATE = "HDECAfterSale/create";
export const HDEC_AFTER_SALE_CLEAR = "HDECAfterSale/clear";
export const HDEC_AFTER_SALE_PAGE_CHANGE = "HDECAfterSale/page_change";
export const HDEC_AFTER_SALE_PAGE_SIZE_CHANGE = "HDECAfterSale/page_size_change";
export const HDEC_AFTER_SALE_PAGE_AREA_CHANGE = "HDECAfterSale/area_change";
export const HDEC_AFTER_SALE_PAGE_COMPANY_CHANGE = "HDECAfterSale/company_change";
export const HDEC_AFTER_SALE_PAGE_PROJECT_CHANGE = "HDECAfterSale/project_change";
export const HDEC_AFTER_SALE_SET_AREA = "HDECAfterSale/set_area";
export const HDEC_AFTER_SALE_SET_PARAMS = "HDECAfterSale/set_params";

export const HDEC_AFTER_SALE_VIEW_SET_CONTRACT = "HDECAfterSaleView/set_contract";
export const HDEC_AFTER_SALE_VIEW_LIST = "HDECAfterSaleView/list";
export const HDEC_AFTER_SALE_VIEW_PAGE_CHANGE = "HDECAfterSaleView/page_change";
export const HDEC_AFTER_SALE_VIEW_PAGE_SIZE_CHANGE = "HDECAfterSaleView/page_size_change";
export const HDEC_AFTER_SALE_VIEW_CLEAR = "HDECAfterSaleView/clear";
export const HDEC_AFTER_SALE_VIEW_MODIFY = "HDECAfterSaleView/modify";

export const HDEC_RECEPTION_LIST = "HDECReceptionManage/list";
export const HDEC_RECEPTION_CUSTOMSOURCE = "HDECReceptionManage/customsource";
export const HDEC_RECEPTION_CLEAR = "HDECReceptionManage/clear";
export const HDEC_RECEPTION_CLEAR_CUSTOMER = "HDECReceptionManage/clear_customer";
export const HDEC_RECEPTION_COPY = "HDECReceptionManage/copy";
export const HDEC_RECEPTION_COPY_BY = "HDECReceptionManage/copy_by";
export const HDEC_RECEPTION_SAVE = "HDECReceptionManage/save";
export const HDEC_RECEPTION_MODIFY = "HDECReceptionManage/modify";
export const HDEC_RECEPTION_CHANGE_AREA = "HDECReceptionManage/change_area";
export const HDEC_RECEPTION_CHANGE_CITY_COMPANIES = "HDECReceptionManage/change_city_companies";
export const HDEC_RECEPTION_SET_AREA = "HDECReceptionManage/set_area";


export const HDEC_RECEPTION_CUSTOMER_LIST = "HDECReceptionCustomer/list";
export const HDEC_RECEPTION_CUSTOMER_REMOVE = "HDECReceptionCustomer/remove";
export const HDEC_RECEPTION_CUSTOMER_MODIFY = "HDECReceptionCustomer/modify";
export const HDEC_RECEPTION_CUSTOMER_CREATE = "HDECReceptionCustomer/create";
export const HDEC_RECEPTION_CUSTOMER_CREATE_BY = "HDECReceptionCustomer/create_by";
export const HDEC_RECEPTION_CUSTOMER_CLEAR = "HDECReceptionCustomer/clear";
export const HDEC_RECEPTION_CUSTOMER_COPY = "HDECReceptionCustomer/copy";
export const HDEC_RECEPTION_CUSTOMER_COPY_BY = "HDECReceptionCustomer/copy_by";
export const HDEC_RECEPTION_CUSTOMER_CHANGE_PAGE = "HDECReceptionCustomer/change_page";
export const HDEC_RECEPTION_CUSTOMER_CHANGE_PAGE_SIZE = "HDECReceptionCustomer/change_page_size";
export const HDEC_RECEPTION_CUSTOMER_LINK_IN = "HDECReceptionCustomer/link_in";
export const HDEC_RECEPTION_CUSTOMER_LINK_IN_SEARCH = "HDECReceptionCustomer/link_in_search";
export const HDEC_RECEPTION_CUSTOMER_SET_AREA = "HDECReceptionCustomer/set_area";
export const HDEC_RECEPTION_CUSTOMER_SET_CITY_COMPANIES = "HDECReceptionCustomer/set_city_companies";
export const HDEC_RECEPTION_CUSTOMER_SET_PROJECTS = "HDECReceptionCustomer/set_projects";
export const HDEC_RECEPTION_CUSTOMER_CHANGE_AREA = "HDECReceptionCustomer/change_area";
export const HDEC_RECEPTION_CUSTOMER_CHANGE_CITY_COMPANIES = "HDECReceptionCustomer/change_city_companies";
export const HDEC_RECEPTION_CUSTOMER_CHANGE_PROJECTS = "HDECReceptionCustomer/change_projects";
export const HDEC_RECEPTION_CUSTOMER_GET_ALL_NAME = "HDECReceptionCustomer/get_all_name";

export const HDEC_CONFIG_MANAGEMENT_BASIC = "HDECBasic/hdec_basic";

export const HDEC_CONFIG_MANAGEMENT_DICT_ITEM_LIST = "HDECConfigDict/item_list";
export const HDEC_CONFIG_MANAGEMENT_DICT_DETAIL_CATGID = "HDECConfigDict/detail_catgid";
export const HDEC_CONFIG_MANAGEMENT_DICT_CREATE = "HDECConfigDict/dick_create";
export const HDEC_CONFIG_MANAGEMENT_DICT_UPDATE = "HDECConfigDict/dick_update";

export const HDEC_CONFIG_MANAGEMENT_COMM_PRODUCT_TYPE = "HDECConfigComm/comm_product_type";
export const HDEC_CONFIG_MANAGEMENT_COMM_YEAR = "HDECConfigComm/comm_year";
export const HDEC_CONFIG_MANAGEMENT_COMM_ADD_YEAR = "HDECConfigComm/comm_add_year";
export const HDEC_CONFIG_MANAGEMENT_COMM_LIST = "HDECConfigComm/comm_list";
export const HDEC_CONFIG_MANAGEMENT_COMM_CREATE = "HDECConfigComm/comm_create";
export const HDEC_CONFIG_MANAGEMENT_COMM_UPDATE = "HDECConfigComm/comm_update";
export const HDEC_CONFIG_MANAGEMENT_COMM_EXPORT_EXCEL = "HDECConfigComm/export_excel";

export const HDEC_CONFIG_MANAGEMENT_YEAR_INCOME_LIST = "HDECConfigRevenue/year_income_list";
export const HDEC_CONFIG_MANAGEMENT_YEAR_INCOME_SAVE = "HDECConfigRevenue/year_income_save";

export const HDEC_CONTRACT_MANAGEMENT_CREATE = "HDECContract/create";
export const HDEC_CONTRACT_MANAGEMENT_DELETE = "HDECContract/delete";
export const HDEC_CONTRACT_MANAGEMENT_MODIFY = "HDECContract/modify";
export const HDEC_CONTRACT_MANAGEMENT_LIST = "HDECContract/contract_list";
export const HDEC_CONTRACT_MANAGEMENT_ECHO_ID = "HDECContract/contract_echo_id";
export const HDEC_CONTRACT_MANAGEMENT_PRODUCT_TYPE = "HDECContract/product_type";
export const HDEC_CONTRACT_MANAGEMENT_SETTLEMENT = "HDECContract/settlement";
export const HDEC_CONTRACT_MANAGEMENT_SURRENDER_ID = "HDECContract/surrender_id";
export const HDEC_CONTRACT_MANAGEMENT_PROJECTLIST_ID = "HDECContract/projectlist_id";
export const HDEC_CONTRACT_MANAGEMENT_BUSINESS_ID = "HDECContract/business_id";
export const HDEC_CONTRACT_EXPORT_EXCEL = "HDECContract/export_excel";
export const HDEC_CONTRACT_CHANGE_PAGE = "HDECContract/change_page";
export const HDEC_CONTRACT_CHANGE_PAGE_SIZE = "HDECContract/change_page_size";
export const HDEC_CONTRACT_CHANGE_SET_PARAMS = "HDECContract/set_params";

export const HDEC_MERCHANT_CREATE = "HDECMerchant/create";
export const HDEC_MERCHANT_MODIFY = "HDECMerchant/modify";
export const HDEC_MERCHANT_DELETE = "HDECMerchant/delete";
export const HDEC_MERCHANT_LIST = "HDECMerchant/list";
export const HDEC_MERCHANT_CONTRACT_BY_ID = "HDECMerchant/contract_by_id";
export const HDEC_MERCHANT_ORDER_BY_ID = "HDECMerchant/order_by_id";
export const HDEC_MERCHANT_PROJECT_BY_ID = "HDECMerchant/project_by_id";
export const HDEC_MERCHANT_EXPORT_EXCEL = "HDECMerchant/export_excel";
export const HDEC_MERCHANT_ID_NAME = "HDECMerchant/id_name";
export const HDEC_MERCHANT_BUSINESS_STATUS = "HDECMerchant/business_status";
export const HDEC_MERCHANT_INIT = "HDECMerchant/init";
export const HDEC_MERCHANT_PRODUCTTYPE = "HDECMerchant/productType"
export const HDEC_MERCHANT_COMMODITYATTRIBUTE = "HDECMerchant/commodityAttribute"

export const HDEC_ORDER_MANAGEMENT_ADDOWN = "HDECOrder/addown";
export const HDEC_ORDER_MANAGEMENT_LIST = "HDECOrder/list";
export const HDEC_ORDER_MANAGEMENT_CREATE = "HDECOrder/create";
export const HDEC_ORDER_MANAGEMENT_MODIFY = "HDECOrder/modify";
export const HDEC_ORDER_MANAGEMENT_DELETE = "HDECOrder/delete";
export const HDEC_ORDER_MANAGEMENT_BUSINESS_ID = "HDECOrder/business_id";
export const HDEC_ORDER_MANAGEMENT_ITEM_ATTR = "HDECOrder/item_attr";
export const HDEC_ORDER_MANAGEMENT_PRODUCT_TYPE = "HDECOrder/product_type";
export const HDEC_ORDER_MANAGEMENT_ORDER_LIST = "HDECOrder/order_list";
export const HDEC_ORDER_MANAGEMENT_ORDER_DETAIL_LIST = "HDECOrder/order_detail_list";
export const HDEC_ORDER_MANAGEMENT_REFUND_GUARANTEE = "HDECOrder/refund_guarantee";

export const HDEC_ORDER_DETAIL_MANAGEMENT_LIST = "HDECOrderMntDetail/detail_list";
export const HDEC_ORDER_DETAIL_MANAGEMENT_CREATE = "HDECOrderMntDetail/detail_create";
export const HDEC_ORDER_DETAIL_MANAGEMENT_MODIFY = "HDECOrderMntDetail/detail_modify";
export const HDEC_ORDER_DETAIL_MANAGEMENT_DELETE = "HDECOrderMntDetail/detail_delete";
export const HDEC_ORDER_ADDORDROP_MANAGEMENT_LIST = "HDECOrderMntDetail/addordrop_list";
export const HDEC_ORDER_ADDORDROP_MANAGEMENT_CREATE = "HDECOrderMntDetail/addordrop_create";
export const HDEC_ORDER_ADDORDROP_MANAGEMENT_MODIFY = "HDECOrderMntDetail/addordrop_modify";
export const HDEC_ORDER_ADDORDROP_MANAGEMENT_DELETE = "HDECOrderMntDetail/addordrop_delete";
export const HDEC_ORDER_MERCHANT_MANAGEMENT_LIST = "HDECOrderMntDetail/merchant_list";
export const HDEC_ORDER_MERCHANT_MANAGEMENT_CREATE = "HDECOrderMntDetail/merchant_create";
export const HDEC_ORDER_MERCHANT_MANAGEMENT_MODIFY = "HDECOrderMntDetail/merchant_modify";
export const HDEC_ORDER_MERCHANT_MANAGEMENT_DELETE = "HDECOrderMntDetail/merchant_delete";
export const HDEC_ORDER_COLLECTION_MANAGEMENT_LIST = "HDECOrderMntDetail/collection_list";
export const HDEC_ORDER_COLLECTION_MANAGEMENT_CREATE = "HDECOrderMntDetail/collection_create";
export const HDEC_ORDER_COLLECTION_MANAGEMENT_MODIFY = "HDECOrderMntDetail/collection_modify";
export const HDEC_ORDER_COLLECTION_MANAGEMENT_DELETE = "HDECOrderMntDetail/collection_delete";
export const HDEC_ORDER_COLLECTION_MANAGEMENT_REFUNDDEPOSIT = "HDECOrderMntDetail/collection_refund_deposit";
export const HDEC_ORDER_PROGRESS_MANAGEMENT_LIST = "HDECOrderMntDetail/progress_list";
export const HDEC_ORDER_PROGRESS_MANAGEMENT_SAVE_PROGRESS = "HDECOrderMntDetail/progress_save";
export const HDEC_ORDER_PROGRESS_MANAGEMENT_UPLOAD = "HDECOrderMntDetail/progress_upload";
export const HDEC_ORDER_TIME_MANAGEMENT_LIST = "HDECOrderMntDetail/time_list";
export const HDEC_ORDER_TIME_MANAGEMENT_UPDATE_DELAYTIME = "HDECOrderMntDetail/update_delaytime";


export const DELICIOUS_BANNER_BANNERS = "DeliciousBanner/banners";
export const DELICIOUS_Classified_Admin = "DeliciousClassified/classList";
export const DELICIOUS_CATEGORY_CLASSIFIED_LIST = "DeliciousCategory/classifiedList";
export const DELICIOUS_STATISTICS = "DeliciousStatistics/statistics";


export const DELICIOUS_SHOP_LIST = "DeliciousShop/getShopList";
export const DELICIOUS_SHOP_UPDATE_CLASSIFY = "DeliciousShop/updateClassify";
export const DELICIOUS_SHOP_TOGGLE_STATUS = "DeliciousShop/toggleStatus";
export const DELICIOUS_SHOP_UPDATE_WEIGHT = "DeliciousShop/updateWeight";
export const DELICIOUS_SHOP_SORT = "DeliciousShop/sort";
export const DELICIOUS_SHOP_SORT_WEIGHT = "DeliciousShop/sortWeight";
export const DELICIOUS_SHOP_CHANGE_SIZE = "DeliciousShop/changeSize";
export const DELICIOUS_SHOP_CHANGE_PAGE = "DeliciousShop/changePage";
export const DELICIOUS_SHOP_SET_CLASSIFY_ID = "DeliciousShop/setClassifyId";

export const DELICIOUS_SHOP_INCREASE_RESET = "DeliciousShopIncrease/reset";
export const DELICIOUS_SHOP_SAVE = "DeliciousShopIncrease/save";

export const DELICIOUS_SHOP_MODIFY_VIEW = "DeliciousShopModify/view";
export const DELICIOUS_SHOP_MODIFY_RESET = "DeliciousShopModify/reset";
export const DELICIOUS_SHOP_MODIFY_UPDATE = "DeliciousShopModify/update";
export const DELICIOUS_SHOP_MODIFY_DETAIL = "DeliciousShopModify/shopDetail";

export const SERVANT_SET_PROJECT_ID = "Servant/setProjectId"
export const SERVANT_LIST = "Servant/list"
export const SERVANT_SAVE = "Servant/save"
export const SERVANT_RESET = "Servant/reset"
export const SERVANT_DETAIL = "Servant/detail"
export const SERVANT_DELETE = "Servant/delete"
export const SERVANT_CHANGE_PAGE = "Servant/changePage"
export const SERVANT_CHANGE_PAGE_SIZE = "Servant/changePageSize"
export const SERVANT_GET_RESOURCES = "Servant/getResources"
export const SERVANT_SAVE_RESOURCE_BY_STAFF = "Servant/saveResourceByStaff"
export const DOOR_LIST = "DoorList/list";
export const DOOR_REMOVE = "DoorList/remove";
export const DOOR_ENABLE = "DoorList/enable";
export const DOOR_DISABLE = "DoorList/disable";
export const DOOR_SET_RESOURCE_ID = "DoorList/setResourceId";
export const DOOR_CHANGE_PAGE = "DoorList/changePage";
export const DOOR_CHANGE_PAGE_SIZE = "DoorList/changePageSize";
// export const CRM_FEEDBACK_LIST = ""
// export const HOUSE_LIST = "house/search"

export const getModuleName = (name) => name.split('/')[1];

export const TYPES = {
  APP_SYSTEMS: getModuleName(APP_SYSTEMS)
  , APP_REMOVE_TAB: getModuleName(APP_REMOVE_TAB)
  , APP_ADD_LOCAL_TAB: getModuleName(APP_ADD_LOCAL_TAB)
  , APP_REMOVE_TABS: getModuleName(APP_REMOVE_TABS)
  , APP_REMOVE_OTHER_TABS: getModuleName(APP_REMOVE_OTHER_TABS)
  , APP_CURRENT_USER: getModuleName(APP_CURRENT_USER)
  , APP_USER_INFO: getModuleName(APP_USER_INFO)
  , APP_MENUS: getModuleName(APP_MENUS)
  , APP_ACTIVE: getModuleName(APP_ACTIVE)
  , APP_MENU_ACTIVE: getModuleName(APP_MENU_ACTIVE)
  , LOGIN: getModuleName(LOGIN)
  , PAGE_HEADER_ACTIVE: getModuleName(PAGE_HEADER_ACTIVE)
  , CLOUD_ROUTE: getModuleName(CLOUD_ROUTE)
  , HOME_MENUS: getModuleName(HOME_MENUS)
  , HOME_INCREASE_TAB: getModuleName(HOME_INCREASE_TAB)
  , DECISION_INCREASE_TAB: getModuleName(DECISION_INCREASE_TAB)
  , ORDER_SYSTEMS: getModuleName(ORDER_SYSTEMS)
  , ORDER_SYSTEM_ORDER: getModuleName(ORDER_SYSTEM_ORDER)

  , COMMON_AREAS: getModuleName(COMMON_AREAS)
  , COMMON_AREAS_CHANGE: getModuleName(COMMON_AREAS_CHANGE)
  , COMMON_CITY_COMPANY: getModuleName(COMMON_CITY_COMPANY)
  , COMMON_PROJECTS: getModuleName(COMMON_PROJECTS)
  , COMMON_BUSINESS_LIST: getModuleName(COMMON_BUSINESS_LIST)
  , COMMON_PROJECT_RESOURCE_LIST: getModuleName(COMMON_PROJECT_RESOURCE_LIST)
  , COMMON_PROJECT_RESOURCE_PARAMS_LIST: getModuleName(COMMON_PROJECT_RESOURCE_PARAMS_LIST)
  , COMMON_PROJECTS_CLEAR: getModuleName(COMMON_PROJECTS_CLEAR)
  , COMMON_CITY_COMPANY_CLEAR: getModuleName(COMMON_CITY_COMPANY_CLEAR)
  , COMMON_CITY_COMPANY_CHANGE: getModuleName(COMMON_CITY_COMPANY_CHANGE)
  , COMMON_ORG_TREE: getModuleName(COMMON_ORG_TREE)
  , COMMON_SYSAREA_AREATREE: getModuleName(COMMON_SYSAREA_AREATREE)
  , COMMON_PROJECT_RESOURCE_PROJECTS: getModuleName(COMMON_PROJECT_RESOURCE_PROJECTS)
  , COMMON_PROJECT_RESOURCE_PROJECTS_DA: getModuleName(COMMON_PROJECT_RESOURCE_PROJECTS_DA)
  , COMMON_ORG_AREA_CITY_BY_PROJECTIDS: getModuleName(COMMON_ORG_AREA_CITY_BY_PROJECTIDS)

  , SETTING_INCREASE_TAB: getModuleName(SETTING_INCREASE_TAB)
  , SETTING_SUB_SYSTEM_LIST: getModuleName(SETTING_SUB_SYSTEM_LIST)
  , SETTING_SUB_SYSTEM_MENUS: getModuleName(SETTING_SUB_SYSTEM_MENUS)
  , SETTING_SUB_SYSTEM_BUTTONS: getModuleName(SETTING_SUB_SYSTEM_BUTTONS)
  , SETTING_SUB_SYSTEM_CREATE: getModuleName(SETTING_SUB_SYSTEM_CREATE)
  , SETTING_SUB_SYSTEM_MODIFY: getModuleName(SETTING_SUB_SYSTEM_MODIFY)
  , SETTING_MENU_MODIFY: getModuleName(SETTING_MENU_MODIFY)
  , SETTING_MENU_CREATE: getModuleName(SETTING_MENU_CREATE)
  , SETTING_SUB_SYSTEM_CLEAR: getModuleName(SETTING_SUB_SYSTEM_CLEAR)
  , SETTING_ROLE_LIST: getModuleName(SETTING_ROLE_LIST)
  , SETTING_ROLE_CREATE: getModuleName(SETTING_ROLE_CREATE)
  , SETTING_ROLE_MODIFY: getModuleName(SETTING_ROLE_MODIFY)
  , SETTING_ROLE_CLEAR: getModuleName(SETTING_ROLE_CLEAR)
  , SETTING_ROLE_NORMAL_LIST: getModuleName(SETTING_ROLE_NORMAL_LIST)
  , SETTING_ROLE_LIST_BY_MANAGER: getModuleName(SETTING_ROLE_LIST_BY_MANAGER)
  , SETTING_ROLE_RELATION: getModuleName(SETTING_ROLE_RELATION)
  , SETTING_ROLE_APP_TREE: getModuleName(SETTING_ROLE_APP_TREE)
  , SETTING_ROLE_ALLOCATE_BUTTON_LIST: getModuleName(SETTING_ROLE_ALLOCATE_BUTTON_LIST)
  , SETTING_ROLE_ALLOCATE_BUTTON_SAVE: getModuleName(SETTING_ROLE_ALLOCATE_BUTTON_SAVE)

  , SETTING_TENANCY_LIST: getModuleName(SETTING_TENANCY_LIST)
  , SETTING_TENANCY_CREATE: getModuleName(SETTING_TENANCY_CREATE)
  , SETTING_TENANCY_MODIFY: getModuleName(SETTING_TENANCY_MODIFY)
  , SETTING_TENANCY_ALLOCATE: getModuleName(SETTING_TENANCY_ALLOCATE)
  , SETTING_TENANCY_SAVE_LIST: getModuleName(SETTING_TENANCY_SAVE_LIST)
  , SETTING_TENANCY_CHECKED_LIST: getModuleName(SETTING_TENANCY_CHECKED_LIST)
  , SETTING_TENANCY_CHECKED_BUTTON_LIST: getModuleName(SETTING_TENANCY_CHECKED_BUTTON_LIST)

  , SETTING_ORG_TREE: getModuleName(SETTING_ORG_TREE)
  , SETTING_ORG_LIST: getModuleName(SETTING_ORG_LIST)
  , SETTING_ORG_CREATE: getModuleName(SETTING_ORG_CREATE)
  , SETTING_ORG_MODIFY: getModuleName(SETTING_ORG_MODIFY)
  , SETTING_ORG_MARK: getModuleName(SETTING_ORG_MARK)
  , SETTING_ORG_UPDATE: getModuleName(SETTING_ORG_UPDATE)
  , SETTING_ORG_DICT_TYPES: getModuleName(SETTING_ORG_DICT_TYPES)
  , SETTING_ORG_FORM_CLEAR: getModuleName(SETTING_ORG_FORM_CLEAR)
  , SETTING_ORG_GRID_CLEAR: getModuleName(SETTING_ORG_GRID_CLEAR)
  , SETTING_ORG_MOVE: getModuleName(SETTING_ORG_MOVE)
  , SETTING_ORG_MOVE_TREE_DATA: getModuleName(SETTING_ORG_MOVE_TREE_DATA)

  , SETTING_POST_ORG_FIND_TREE: getModuleName(SETTING_POST_ORG_FIND_TREE)
  , SETTING_ORG_TREE_FIND_LIST: getModuleName(SETTING_ORG_TREE_FIND_LIST)
  , SETTING_ORG_POST_CREATE: getModuleName(SETTING_ORG_POST_CREATE)
  , SETTING_ORG_POST_MODIFY: getModuleName(SETTING_ORG_POST_MODIFY)
  , SETTING_ORG_POST_WB_ADD: getModuleName(SETTING_ORG_POST_WB_ADD)
  , SETTING_ORG_POST_WB_UPDATE: getModuleName(SETTING_ORG_POST_WB_UPDATE)
  , SETTING_ORG_POST_WB_PERSONNEL: getModuleName(SETTING_ORG_POST_WB_PERSONNEL)
  , SETTING_ORG_POST_WB_NAME_PERSONLIST: getModuleName(SETTING_ORG_POST_WB_NAME_PERSONLIST)
  , SETTING_ORG_POST_WB_REMOVE_PERSON: getModuleName(SETTING_ORG_POST_WB_REMOVE_PERSON)
  , SETTING_ORG_POST_WB_ADD_PERSON: getModuleName(SETTING_ORG_POST_WB_ADD_PERSON)
  , SETTING_ORG_POST_CHANGE_STATUS: getModuleName(SETTING_ORG_POST_CHANGE_STATUS)
  , SETTING_POS_ORG_FIND_ROLE_LIST: getModuleName(SETTING_POS_ORG_FIND_ROLE_LIST)
  , SETTING_POST_ORG_FIND_ROLE_LIST_ID: getModuleName(SETTING_POST_ORG_FIND_ROLE_LIST_ID)
  , SETTING_ORG_POST_REMOVE_ROLE: getModuleName(SETTING_ORG_POST_REMOVE_ROLE)
  , SETTING_POS_DATA_AUTH_FIND_TREE_ID: getModuleName(SETTING_POS_DATA_AUTH_FIND_TREE_ID)
  , SETTING_POS_DATA_AUTH_FIND_PROJECT_TREE: getModuleName(SETTING_POS_DATA_AUTH_FIND_PROJECT_TREE)
  , SETTING_POS_DATA_AUTH_FIND_ORG_TREE_ID: getModuleName(SETTING_POS_DATA_AUTH_FIND_ORG_TREE_ID)
  , SETTING_POS_DATA_AUTH_SAVE: getModuleName(SETTING_POS_DATA_AUTH_SAVE)

  , SETTING_ORG_POST_WB_PERSONLIST: getModuleName(SETTING_ORG_POST_WB_PERSONLIST)
  , SETTING_ORG_POST_WB_POST_TREE: getModuleName(SETTING_ORG_POST_WB_POST_TREE)
  , SETTING_ORG_POST_WB_ADD_PERSONNEL: getModuleName(SETTING_ORG_POST_WB_ADD_PERSONNEL)
  , SETTING_ORG_POST_WB_EDIT_PERSONNEL: getModuleName(SETTING_ORG_POST_WB_EDIT_PERSONNEL)
  , SETTING_ORG_POST_WB_CHANGE_STATUS: getModuleName(SETTING_ORG_POST_WB_CHANGE_STATUS)
  , SETTING_ORG_POST_WB_CHANGE_PWD: getModuleName(SETTING_ORG_POST_WB_CHANGE_PWD)

  , SETTING_ORG_EMPLOYEE_CREATE: getModuleName(SETTING_ORG_EMPLOYEE_CREATE)
  , SETTING_ORG_EMPLOYEE_MODIFY: getModuleName(SETTING_ORG_EMPLOYEE_MODIFY)
  , SETTING_DICK_FIND_CODE: getModuleName(SETTING_DICK_FIND_CODE)
  , SETTING_ORG_EMPLOYEE_LIST: getModuleName(SETTING_ORG_EMPLOYEE_LIST)
  , SETTING_ORG_EMPLOYEE_FIND_ROLE_LIST: getModuleName(SETTING_ORG_EMPLOYEE_FIND_ROLE_LIST)
  , SETTING_ORG_EMPLOYEE_REMOVE_STAFF_MENU: getModuleName(SETTING_ORG_EMPLOYEE_REMOVE_STAFF_MENU)
  , SETTING_ORG_EMPLOYEE_FIND_MENU_ROLE_ID: getModuleName(SETTING_ORG_EMPLOYEE_FIND_MENU_ROLE_ID)
  , SETTING_EMPLOYEE_FIND_STAFF_POS_TREE: getModuleName(SETTING_EMPLOYEE_FIND_STAFF_POS_TREE)
  , SETTING_EMPLOYEE_FIND_MENU_LIST: getModuleName(SETTING_EMPLOYEE_FIND_MENU_LIST)
  , SETTING_EMPLOYEE_DATA_AUTH_FIND_ORG_STAFF_TREE: getModuleName(SETTING_EMPLOYEE_DATA_AUTH_FIND_ORG_STAFF_TREE)
  , SETTING_EMPLOYEE_DATA_AUTH_SAVE_STAFF_REMOVE: getModuleName(SETTING_EMPLOYEE_DATA_AUTH_SAVE_STAFF_REMOVE)
  , SETTING_EMPLOYEE_ORG_FIND_TREE: getModuleName(SETTING_EMPLOYEE_ORG_FIND_TREE)
  // , SETTING_JURISDICTION_ORG_FIND_TREE:getModuleName(SETTING_JURISDICTION_ORG_FIND_TREE)

  , SETTING_PROPERTY_POST_FIND_LIST: getModuleName(SETTING_PROPERTY_POST_FIND_LIST)
  , SETTING_PROPERTY_POST_FIND_KEY: getModuleName(SETTING_PROPERTY_POST_FIND_KEY)
  , SETTING_PROPERTY_POST_CREATE: getModuleName(SETTING_PROPERTY_POST_CREATE)
  , SETTING_PROPERTY_POST_MODIFY: getModuleName(SETTING_PROPERTY_POST_MODIFY)
  , SETTING_PROPERTY_POST_FIND_POS: getModuleName(SETTING_PROPERTY_POST_FIND_POS)
  , SETTING_PROPERTY_POST_FIND_ROLE_LIST: getModuleName(SETTING_PROPERTY_POST_FIND_ROLE_LIST)
  , SETTING_PROPERTY_POST_FIND_ROLE_LIST_ID: getModuleName(SETTING_PROPERTY_POST_FIND_ROLE_LIST_ID)
  , SETTING_PROPERTY_POST_FIND_MENU_ROLE_ID: getModuleName(SETTING_PROPERTY_POST_FIND_MENU_ROLE_ID)
  , SETTING_PROPERTY_POST_SAVE_PROPERTY_ROLE: getModuleName(SETTING_PROPERTY_POST_SAVE_PROPERTY_ROLE)

  , ADVERTISING_AD_LIST: getModuleName(ADVERTISING_AD_LIST)
  , ADVERTISING_AD_ACTIVEADMIN: getModuleName(ADVERTISING_AD_ACTIVEADMIN)
  , ADVERTISING_AD_LIST_RESET: getModuleName(ADVERTISING_AD_LIST_RESET)
  , ADVERTISING_AD_LIST_CHANGE_CURRENT_PAGE: getModuleName(ADVERTISING_AD_LIST_CHANGE_CURRENT_PAGE)
  , ADVERTISING_AD_LIST_CHANGE_CURRENT_SIZE: getModuleName(ADVERTISING_AD_LIST_CHANGE_CURRENT_SIZE)
  , ADVERTISING_AD_ITEM: getModuleName(ADVERTISING_AD_ITEM)
  , ADVERTISING_AD_ITEM_UPDATE: getModuleName(ADVERTISING_AD_ITEM_UPDATE)
  , ADVERTISING_AD_ITEM_CREATE: getModuleName(ADVERTISING_AD_ITEM_CREATE)
  , ADVERTISING_AD_ITEM_DELETE: getModuleName(ADVERTISING_AD_ITEM_DELETE)
  , ADVERTISING_AD_LIST_GB: getModuleName(ADVERTISING_AD_LIST_GB)
  , ADVERTISING_AD_ITEM_GB: getModuleName(ADVERTISING_AD_ITEM_GB)
  , ADVERTISING_AD_ITEM_UPDATE_GB: getModuleName(ADVERTISING_AD_ITEM_UPDATE_GB)
  , ADVERTISING_AD_LIST_RESET_GB: getModuleName(ADVERTISING_AD_LIST_RESET_GB)
  , ADVERTISING_AD_LIST_CHANGE_CURRENT_PAGE_GB: getModuleName(ADVERTISING_AD_LIST_CHANGE_CURRENT_PAGE_GB)
  , ADVERTISING_AD_ITEM_CREATE_GB: getModuleName(ADVERTISING_AD_ITEM_CREATE_GB)
  , ADVERTISING_AD_ITEM_DELETE_GB: getModuleName(ADVERTISING_AD_ITEM_DELETE_GB)
  , ADVERTISING_CALENDAR_LIST: getModuleName(ADVERTISING_CALENDAR_LIST)
  , ADVERTISING_CALENDAR_LIST_GB: getModuleName(ADVERTISING_CALENDAR_LIST_GB)

  , HDEC_CONFIG_MANAGEMENT_HOME: getModuleName(HDEC_CONFIG_MANAGEMENT_HOME)
  , HDEC_CONFIG_MANAGEMENT_HOME_CHOICE: getModuleName(HDEC_CONFIG_MANAGEMENT_HOME_CHOICE)
  , HDEC_CONFIG_MANAGEMENT_HOME_MODIFY: getModuleName(HDEC_CONFIG_MANAGEMENT_HOME_MODIFY)

  , HDEC_PROJECT_SET_AREAS: getModuleName(HDEC_PROJECT_SET_AREAS)
  , HDEC_PROJECT_AREA_CHANGE: getModuleName(HDEC_PROJECT_AREA_CHANGE)
  , HDEC_PROJECT_CITY_COMPANIES_CHANGE: getModuleName(HDEC_PROJECT_CITY_COMPANIES_CHANGE)
  , HDEC_PROJECT_LIST: getModuleName(HDEC_PROJECT_LIST)
  , HDEC_PROJECT_CHANGE_PAGE: getModuleName(HDEC_PROJECT_CHANGE_PAGE)
  , HDEC_PROJECT_CHANGE_PAGE_SIZE: getModuleName(HDEC_PROJECT_CHANGE_PAGE_SIZE)
  , HDEC_PROJECT_EXPORT: getModuleName(HDEC_PROJECT_EXPORT)

  , HDEC_PROJECT_COOPERATION_LIST: getModuleName(HDEC_PROJECT_COOPERATION_LIST)
  , HDEC_PROJECT_COOPERATION_PROJECT_LIST: getModuleName(HDEC_PROJECT_COOPERATION_PROJECT_LIST)
  , HDEC_PROJECT_COOPERATION_BUSINESS_LIST: getModuleName(HDEC_PROJECT_COOPERATION_BUSINESS_LIST)

  , HDEC_HOME_NOTIFICATION: getModuleName(HDEC_HOME_NOTIFICATION)
  , HDEC_HOME_PERCENTAGE: getModuleName(HDEC_HOME_PERCENTAGE)
  , HDEC_HOME_ORDER_TREND: getModuleName(HDEC_HOME_ORDER_TREND)
  , HDEC_HOME_PROJECT_INCOME: getModuleName(HDEC_HOME_PROJECT_INCOME)
  , HDEC_HOME_PROJECT_INCOME_AMOUNT: getModuleName(HDEC_HOME_PROJECT_INCOME_AMOUNT)
  , HDEC_HOME_CONTRACT_OFFSET: getModuleName(HDEC_HOME_CONTRACT_OFFSET)
  , HDEC_HOME_CHANGE_PAGE: getModuleName(HDEC_HOME_CHANGE_PAGE)
  , HDEC_HOME_CHANGE_PAGE_SIZE: getModuleName(HDEC_HOME_CHANGE_PAGE_SIZE)

  , HDEC_CONFIG_MANAGEMENT_DICT_ITEM_LIST: getModuleName(HDEC_CONFIG_MANAGEMENT_DICT_ITEM_LIST)
  , HDEC_CONFIG_MANAGEMENT_BASIC: getModuleName(HDEC_CONFIG_MANAGEMENT_BASIC)
  , HDEC_CONFIG_MANAGEMENT_DICT_DETAIL_CATGID: getModuleName(HDEC_CONFIG_MANAGEMENT_DICT_DETAIL_CATGID)
  , HDEC_CONFIG_MANAGEMENT_DICT_CREATE: getModuleName(HDEC_CONFIG_MANAGEMENT_DICT_CREATE)
  , HDEC_CONFIG_MANAGEMENT_DICT_UPDATE: getModuleName(HDEC_CONFIG_MANAGEMENT_DICT_UPDATE)
  , HDEC_CONFIG_MANAGEMENT_COMM_YEAR: getModuleName(HDEC_CONFIG_MANAGEMENT_COMM_YEAR)
  , HDEC_CONFIG_MANAGEMENT_COMM_ADD_YEAR: getModuleName(HDEC_CONFIG_MANAGEMENT_COMM_ADD_YEAR)
  , HDEC_CONFIG_MANAGEMENT_COMM_LIST: getModuleName(HDEC_CONFIG_MANAGEMENT_COMM_LIST)
  , HDEC_CONFIG_MANAGEMENT_COMM_PRODUCT_TYPE: getModuleName(HDEC_CONFIG_MANAGEMENT_COMM_PRODUCT_TYPE)
  , HDEC_CONFIG_MANAGEMENT_COMM_CREATE: getModuleName(HDEC_CONFIG_MANAGEMENT_COMM_CREATE)
  , HDEC_CONFIG_MANAGEMENT_COMM_UPDATE: getModuleName(HDEC_CONFIG_MANAGEMENT_COMM_UPDATE)
  , HDEC_CONFIG_MANAGEMENT_COMM_EXPORT_EXCEL: getModuleName(HDEC_CONFIG_MANAGEMENT_COMM_EXPORT_EXCEL)

  , HDEC_CONFIG_MANAGEMENT_YEAR_INCOME_LIST: getModuleName(HDEC_CONFIG_MANAGEMENT_YEAR_INCOME_LIST)
  , HDEC_CONFIG_MANAGEMENT_YEAR_INCOME_SAVE: getModuleName(HDEC_CONFIG_MANAGEMENT_YEAR_INCOME_SAVE)

  , HDEC_CONTRACT_MANAGEMENT_CREATE: getModuleName(HDEC_CONTRACT_MANAGEMENT_CREATE)
  , HDEC_CONTRACT_MANAGEMENT_DELETE: getModuleName(HDEC_CONTRACT_MANAGEMENT_DELETE)
  , HDEC_CONTRACT_MANAGEMENT_MODIFY: getModuleName(HDEC_CONTRACT_MANAGEMENT_MODIFY)
  , HDEC_CONTRACT_MANAGEMENT_LIST: getModuleName(HDEC_CONTRACT_MANAGEMENT_LIST)
  , HDEC_CONTRACT_MANAGEMENT_ECHO_ID: getModuleName(HDEC_CONTRACT_MANAGEMENT_ECHO_ID)
  , HDEC_CONTRACT_MANAGEMENT_PRODUCT_TYPE: getModuleName(HDEC_CONTRACT_MANAGEMENT_PRODUCT_TYPE)
  , HDEC_CONTRACT_MANAGEMENT_SETTLEMENT: getModuleName(HDEC_CONTRACT_MANAGEMENT_SETTLEMENT)
  , HDEC_CONTRACT_MANAGEMENT_SURRENDER_ID: getModuleName(HDEC_CONTRACT_MANAGEMENT_SURRENDER_ID)
  , HDEC_CONTRACT_MANAGEMENT_PROJECTLIST_ID: getModuleName(HDEC_CONTRACT_MANAGEMENT_PROJECTLIST_ID)
  , HDEC_CONTRACT_MANAGEMENT_BUSINESS_ID: getModuleName(HDEC_CONTRACT_MANAGEMENT_BUSINESS_ID)
  , HDEC_CONTRACT_EXPORT_EXCEL: getModuleName(HDEC_CONTRACT_EXPORT_EXCEL)
  , HDEC_CONTRACT_CHANGE_PAGE: getModuleName(HDEC_CONTRACT_CHANGE_PAGE)
  , HDEC_CONTRACT_CHANGE_PAGE_SIZE: getModuleName(HDEC_CONTRACT_CHANGE_PAGE_SIZE)
  , HDEC_CONTRACT_CHANGE_SET_PARAMS: getModuleName(HDEC_CONTRACT_CHANGE_SET_PARAMS)

  , HDEC_MERCHANT_CREATE: getModuleName(HDEC_MERCHANT_CREATE)
  , HDEC_MERCHANT_MODIFY: getModuleName(HDEC_MERCHANT_MODIFY)
  , HDEC_MERCHANT_DELETE: getModuleName(HDEC_MERCHANT_DELETE)
  , HDEC_MERCHANT_LIST: getModuleName(HDEC_MERCHANT_LIST)
  , HDEC_MERCHANT_CONTRACT_BY_ID: getModuleName(HDEC_MERCHANT_CONTRACT_BY_ID)
  , HDEC_MERCHANT_ORDER_BY_ID: getModuleName(HDEC_MERCHANT_ORDER_BY_ID)
  , HDEC_MERCHANT_PROJECT_BY_ID: getModuleName(HDEC_MERCHANT_PROJECT_BY_ID)
  , HDEC_MERCHANT_EXPORT_EXCEL: getModuleName(HDEC_MERCHANT_EXPORT_EXCEL)
  , HDEC_MERCHANT_ID_NAME: getModuleName(HDEC_MERCHANT_ID_NAME)
  , HDEC_MERCHANT_BUSINESS_STATUS: getModuleName(HDEC_MERCHANT_BUSINESS_STATUS)
  , HDEC_MERCHANT_INIT: getModuleName(HDEC_MERCHANT_INIT)
  , HDEC_MERCHANT_PRODUCTTYPE: getModuleName(HDEC_MERCHANT_PRODUCTTYPE)
  , HDEC_MERCHANT_COMMODITYATTRIBUTE: getModuleName(HDEC_MERCHANT_COMMODITYATTRIBUTE)

  , HDEC_ORDER_MANAGEMENT_ADDOWN: getModuleName(HDEC_ORDER_MANAGEMENT_ADDOWN)
  , HDEC_ORDER_MANAGEMENT_LIST: getModuleName(HDEC_ORDER_MANAGEMENT_LIST)
  , HDEC_ORDER_MANAGEMENT_CREATE: getModuleName(HDEC_ORDER_MANAGEMENT_CREATE)
  , HDEC_ORDER_MANAGEMENT_MODIFY: getModuleName(HDEC_ORDER_MANAGEMENT_MODIFY)
  , HDEC_ORDER_MANAGEMENT_DELETE: getModuleName(HDEC_ORDER_MANAGEMENT_DELETE)
  , HDEC_ORDER_MANAGEMENT_BUSINESS_ID: getModuleName(HDEC_ORDER_MANAGEMENT_BUSINESS_ID)
  , HDEC_ORDER_MANAGEMENT_ITEM_ATTR: getModuleName(HDEC_ORDER_MANAGEMENT_ITEM_ATTR)
  , HDEC_ORDER_MANAGEMENT_PRODUCT_TYPE: getModuleName(HDEC_ORDER_MANAGEMENT_PRODUCT_TYPE)
  , HDEC_ORDER_MANAGEMENT_ORDER_LIST: getModuleName(HDEC_ORDER_MANAGEMENT_ORDER_LIST)
  , HDEC_ORDER_MANAGEMENT_ORDER_DETAIL_LIST: getModuleName(HDEC_ORDER_MANAGEMENT_ORDER_DETAIL_LIST)
  , HDEC_ORDER_MANAGEMENT_REFUND_GUARANTEE: getModuleName(HDEC_ORDER_MANAGEMENT_REFUND_GUARANTEE)

  , HDEC_ORDER_DETAIL_MANAGEMENT_LIST: getModuleName(HDEC_ORDER_DETAIL_MANAGEMENT_LIST)
  , HDEC_ORDER_DETAIL_MANAGEMENT_CREATE: getModuleName(HDEC_ORDER_DETAIL_MANAGEMENT_CREATE)
  , HDEC_ORDER_DETAIL_MANAGEMENT_MODIFY: getModuleName(HDEC_ORDER_DETAIL_MANAGEMENT_MODIFY)
  , HDEC_ORDER_DETAIL_MANAGEMENT_DELETE: getModuleName(HDEC_ORDER_DETAIL_MANAGEMENT_DELETE)
  , HDEC_ORDER_ADDORDROP_MANAGEMENT_LIST: getModuleName(HDEC_ORDER_ADDORDROP_MANAGEMENT_LIST)
  , HDEC_ORDER_ADDORDROP_MANAGEMENT_CREATE: getModuleName(HDEC_ORDER_ADDORDROP_MANAGEMENT_CREATE)
  , HDEC_ORDER_ADDORDROP_MANAGEMENT_MODIFY: getModuleName(HDEC_ORDER_ADDORDROP_MANAGEMENT_MODIFY)
  , HDEC_ORDER_ADDORDROP_MANAGEMENT_DELETE: getModuleName(HDEC_ORDER_ADDORDROP_MANAGEMENT_DELETE)
  , HDEC_ORDER_MERCHANT_MANAGEMENT_LIST: getModuleName(HDEC_ORDER_MERCHANT_MANAGEMENT_LIST)
  , HDEC_ORDER_MERCHANT_MANAGEMENT_CREATE: getModuleName(HDEC_ORDER_MERCHANT_MANAGEMENT_CREATE)
  , HDEC_ORDER_MERCHANT_MANAGEMENT_MODIFY: getModuleName(HDEC_ORDER_MERCHANT_MANAGEMENT_MODIFY)
  , HDEC_ORDER_MERCHANT_MANAGEMENT_DELETE: getModuleName(HDEC_ORDER_MERCHANT_MANAGEMENT_DELETE)
  , HDEC_ORDER_COLLECTION_MANAGEMENT_LIST: getModuleName(HDEC_ORDER_COLLECTION_MANAGEMENT_LIST)
  , HDEC_ORDER_COLLECTION_MANAGEMENT_CREATE: getModuleName(HDEC_ORDER_COLLECTION_MANAGEMENT_CREATE)
  , HDEC_ORDER_COLLECTION_MANAGEMENT_MODIFY: getModuleName(HDEC_ORDER_COLLECTION_MANAGEMENT_MODIFY)
  , HDEC_ORDER_COLLECTION_MANAGEMENT_DELETE: getModuleName(HDEC_ORDER_COLLECTION_MANAGEMENT_DELETE)
  , HDEC_ORDER_COLLECTION_MANAGEMENT_REFUNDDEPOSIT: getModuleName(HDEC_ORDER_COLLECTION_MANAGEMENT_REFUNDDEPOSIT)
  , HDEC_ORDER_PROGRESS_MANAGEMENT_LIST: getModuleName(HDEC_ORDER_PROGRESS_MANAGEMENT_LIST)
  , HDEC_ORDER_PROGRESS_MANAGEMENT_SAVE_PROGRESS: getModuleName(HDEC_ORDER_PROGRESS_MANAGEMENT_SAVE_PROGRESS)
  , HDEC_ORDER_PROGRESS_MANAGEMENT_UPLOAD: getModuleName(HDEC_ORDER_PROGRESS_MANAGEMENT_UPLOAD)
  , HDEC_ORDER_TIME_MANAGEMENT_LIST: getModuleName(HDEC_ORDER_TIME_MANAGEMENT_LIST)
  , HDEC_ORDER_TIME_MANAGEMENT_UPDATE_DELAYTIME: getModuleName(HDEC_ORDER_TIME_MANAGEMENT_UPDATE_DELAYTIME)

  , HDEC_CONFIG_MANAGEMENT_HOME_DELETE: getModuleName(HDEC_CONFIG_MANAGEMENT_HOME_DELETE)

  , HDEC_AFTER_SALE_LIST: getModuleName(HDEC_AFTER_SALE_LIST)
  , HDEC_AFTER_SALE_COPY_MODIFY: getModuleName(HDEC_AFTER_SALE_COPY_MODIFY)
  , HDEC_AFTER_SALE_CONTRACT_LIST: getModuleName(HDEC_AFTER_SALE_CONTRACT_LIST)
  , HDEC_AFTER_SALE_CLEAR: getModuleName(HDEC_AFTER_SALE_CLEAR)
  , HDEC_AFTER_SALE_MODIFY: getModuleName(HDEC_AFTER_SALE_MODIFY)
  , HDEC_AFTER_SALE_CREATE: getModuleName(HDEC_AFTER_SALE_CREATE)
  , HDEC_AFTER_SALE_PAGE_CHANGE: getModuleName(HDEC_AFTER_SALE_PAGE_CHANGE)
  , HDEC_AFTER_SALE_PAGE_SIZE_CHANGE: getModuleName(HDEC_AFTER_SALE_PAGE_SIZE_CHANGE)
  , HDEC_AFTER_SALE_PAGE_AREA_CHANGE: getModuleName(HDEC_AFTER_SALE_PAGE_AREA_CHANGE)
  , HDEC_AFTER_SALE_PAGE_COMPANY_CHANGE: getModuleName(HDEC_AFTER_SALE_PAGE_COMPANY_CHANGE)
  , HDEC_AFTER_SALE_PAGE_PROJECT_CHANGE: getModuleName(HDEC_AFTER_SALE_PAGE_PROJECT_CHANGE)
  , HDEC_AFTER_SALE_SET_AREA: getModuleName(HDEC_AFTER_SALE_SET_AREA)
  , HDEC_AFTER_SALE_SET_PARAMS: getModuleName(HDEC_AFTER_SALE_SET_PARAMS)

  , HDEC_AFTER_SALE_VIEW_SET_CONTRACT: getModuleName(HDEC_AFTER_SALE_VIEW_SET_CONTRACT)
  , HDEC_AFTER_SALE_VIEW_LIST: getModuleName(HDEC_AFTER_SALE_VIEW_LIST)
  , HDEC_AFTER_SALE_VIEW_PAGE_CHANGE: getModuleName(HDEC_AFTER_SALE_VIEW_PAGE_CHANGE)
  , HDEC_AFTER_SALE_VIEW_PAGE_SIZE_CHANGE: getModuleName(HDEC_AFTER_SALE_VIEW_PAGE_SIZE_CHANGE)
  , HDEC_AFTER_SALE_VIEW_CLEAR: getModuleName(HDEC_AFTER_SALE_VIEW_CLEAR)
  , HDEC_AFTER_SALE_VIEW_MODIFY: getModuleName(HDEC_AFTER_SALE_VIEW_MODIFY)

  , HDEC_RECEPTION_LIST: getModuleName(HDEC_RECEPTION_LIST)
  , HDEC_RECEPTION_CUSTOMSOURCE: getModuleName(HDEC_RECEPTION_CUSTOMSOURCE)
  , HDEC_RECEPTION_CLEAR: getModuleName(HDEC_RECEPTION_CLEAR)
  , HDEC_RECEPTION_CLEAR_CUSTOMER: getModuleName(HDEC_RECEPTION_CLEAR_CUSTOMER)
  , HDEC_RECEPTION_COPY: getModuleName(HDEC_RECEPTION_COPY)
  , HDEC_RECEPTION_COPY_BY: getModuleName(HDEC_RECEPTION_COPY_BY)
  , HDEC_RECEPTION_SAVE: getModuleName(HDEC_RECEPTION_SAVE)
  , HDEC_RECEPTION_MODIFY: getModuleName(HDEC_RECEPTION_MODIFY)
  , HDEC_RECEPTION_CHANGE_AREA: getModuleName(HDEC_RECEPTION_CHANGE_AREA)
  , HDEC_RECEPTION_CHANGE_CITY_COMPANIES: getModuleName(HDEC_RECEPTION_CHANGE_CITY_COMPANIES)
  , HDEC_RECEPTION_SET_AREA: getModuleName(HDEC_RECEPTION_SET_AREA)

  , HDEC_RECEPTION_CUSTOMER_LIST: getModuleName(HDEC_RECEPTION_CUSTOMER_LIST)
  , HDEC_RECEPTION_CUSTOMER_REMOVE: getModuleName(HDEC_RECEPTION_CUSTOMER_REMOVE)
  , HDEC_RECEPTION_CUSTOMER_CREATE: getModuleName(HDEC_RECEPTION_CUSTOMER_CREATE)
  , HDEC_RECEPTION_CUSTOMER_MODIFY: getModuleName(HDEC_RECEPTION_CUSTOMER_MODIFY)
  , HDEC_RECEPTION_CUSTOMER_CREATE_BY: getModuleName(HDEC_RECEPTION_CUSTOMER_CREATE_BY)
  , HDEC_RECEPTION_CUSTOMER_CLEAR: getModuleName(HDEC_RECEPTION_CUSTOMER_CLEAR)
  , HDEC_RECEPTION_CUSTOMER_COPY: getModuleName(HDEC_RECEPTION_CUSTOMER_COPY)
  , HDEC_RECEPTION_CUSTOMER_COPY_BY: getModuleName(HDEC_RECEPTION_CUSTOMER_COPY_BY)
  , HDEC_RECEPTION_CUSTOMER_CHANGE_PAGE: getModuleName(HDEC_RECEPTION_CUSTOMER_CHANGE_PAGE)
  , HDEC_RECEPTION_CUSTOMER_CHANGE_PAGE_SIZE: getModuleName(HDEC_RECEPTION_CUSTOMER_CHANGE_PAGE_SIZE)
  , HDEC_RECEPTION_CUSTOMER_LINK_IN: getModuleName(HDEC_RECEPTION_CUSTOMER_LINK_IN)
  , HDEC_RECEPTION_CUSTOMER_LINK_IN_SEARCH: getModuleName(HDEC_RECEPTION_CUSTOMER_LINK_IN_SEARCH)
  , HDEC_RECEPTION_CUSTOMER_SET_AREA: getModuleName(HDEC_RECEPTION_CUSTOMER_SET_AREA)
  , HDEC_RECEPTION_CUSTOMER_CHANGE_AREA: getModuleName(HDEC_RECEPTION_CUSTOMER_CHANGE_AREA)
  , HDEC_RECEPTION_CUSTOMER_CHANGE_CITY_COMPANIES: getModuleName(HDEC_RECEPTION_CUSTOMER_CHANGE_CITY_COMPANIES)
  , HDEC_RECEPTION_CUSTOMER_CHANGE_PROJECTS: getModuleName(HDEC_RECEPTION_CUSTOMER_CHANGE_PROJECTS)
  , HDEC_RECEPTION_CUSTOMER_GET_ALL_NAME: getModuleName(HDEC_RECEPTION_CUSTOMER_GET_ALL_NAME)
};
